var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 100,
    viewBox: "0 0 170 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1611 99.4365C16.2725 99.4365 1.24609 87.0381 0.639648 69.4512H19.4395C20.585 77.6719 27.8623 83.332 37.2959 83.332C47.9424 83.332 55.2871 75.9199 55.2871 65.3408C55.2871 54.5596 47.9424 47.0127 37.4307 47.0127C30.0859 47.0127 23.752 50.3818 20.3828 55.9746H2.18945L6.97363 0.046875H68.8311V16.2188H22.9434L20.7197 42.835H21.124C25.0996 36.2988 32.8486 32.1885 42.7539 32.1885C61.3516 32.1885 74.6934 45.8672 74.6934 64.8018C74.6934 85.4209 59.4648 99.4365 37.1611 99.4365ZM80.6904 97.2803L111.552 48.5625V48.0234L80.8926 0.046875H104.813L125.433 35.0859H125.972L146.793 0.046875H169.501L137.696 48.4277V48.8994L169.097 97.2803H145.917L124.624 63.252H124.085L102.657 97.2803H80.6904Z",
    fill: "url(#paint0_linear_4488_6104)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4488_6104",
    x1: 6.79548,
    y1: -7.21973,
    x2: 158.261,
    y2: 115.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2483FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5X);
export default __webpack_public_path__ + "static/media/5X.94cad9a0ce2a9933b9f789a728973630.svg";
export { ForwardRef as ReactComponent };